import {
  GoalAnalyticsDataSelector,
  GoalAnalyticsMetricKey,
  GoalAnalyticsMetricsData,
  KeyofGoalAnalyticsMetricValue,
} from '../types';

export const metricsDataExtractor = (
  data: GoalAnalyticsMetricsData,
  selectors: GoalAnalyticsDataSelector[],
) =>
  selectors.reduce(
    (acc, [key, keyofMetric, keyName]) => ({
      ...acc,
      [keyName || key]: data?.[key]?.[keyofMetric],
    }),
    {},
  );

export const getPerformanceMetrics = (metrics: GoalAnalyticsMetricsData) =>
  metricsDataExtractor(metrics, [
    [
      GoalAnalyticsMetricKey.TOTAL_GOAL_CONVERSIONS,
      KeyofGoalAnalyticsMetricValue.HISTOGRAM,
      'graphData',
    ],
    [GoalAnalyticsMetricKey.TOTAL_GOAL_CONVERSIONS, KeyofGoalAnalyticsMetricValue.VALUE],
    [GoalAnalyticsMetricKey.UNIQUE_GOAL_CONVERSIONS, KeyofGoalAnalyticsMetricValue.VALUE],
    [
      GoalAnalyticsMetricKey.TOTAL_GOAL_CONVERSIONS_BY_TOTAL_MESSAGES_SENT,
      KeyofGoalAnalyticsMetricValue.VALUE,
    ],
    [
      GoalAnalyticsMetricKey.UNIQUE_GOAL_CONVERSIONS_BY_UNIQUE_MESSAGES_SENT,
      KeyofGoalAnalyticsMetricValue.VALUE,
    ],
    [GoalAnalyticsMetricKey.TOTAL_SENT, KeyofGoalAnalyticsMetricValue.VALUE],
  ]);

export const getRevenueMetrics = (metrics: GoalAnalyticsMetricsData) =>
  metricsDataExtractor(metrics, [
    [GoalAnalyticsMetricKey.REVENUE, KeyofGoalAnalyticsMetricValue.HISTOGRAM, 'graphData'],
    [GoalAnalyticsMetricKey.REVENUE, KeyofGoalAnalyticsMetricValue.VALUE],
  ]);
